import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { CONTACT } from "../constants/contact";
import { trackWhatsAppContact } from "../helper/facebookPixel";
import useBusinessHours from "../hooks/useBusinessHours";
import { CHAPA_SERVICES_DATA } from "../data/chapaData";
import { MECANICA_SERVICES_DATA } from "../data/mecanicaData";
import { MANTENIMIENTO_SERVICES_DATA } from "../data/mantenimientoData";

const HeaderOne = () => {
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);
  const { isOpen, statusMessage, summary, loading, error } = useBusinessHours();

  useEffect(() => {
    // Offcanvas Submenu Setup
    const offCanvasNav = document.getElementById("offcanvas-navigation");
    if (offCanvasNav) {
      const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu");

      // Insert expand buttons
      offCanvasNavSubMenu.forEach((submenu) => {
        submenu.insertAdjacentHTML(
          "beforebegin",
          "<span class='mean-expand-class'>+</span>"
        );
      });

      const menuExpand = offCanvasNav.querySelectorAll(".mean-expand-class");
      menuExpand.forEach((expand) => {
        expand.addEventListener("click", function () {
          // Toggle active class
          if (this.parentElement.classList.contains("active")) {
            this.parentElement.classList.remove("active");
          } else {
            menuExpand.forEach((el) => el.parentElement.classList.remove("active"));
            this.parentElement.classList.add("active");
          }
        });
      });
    }

    // Sticky Menu on Scroll
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
  }, []);

  const mobileMenu = () => {
    setActive(!active);
  };

  return (
    <>
      <header className="nav-header header-layout1">
        {/* Header Top */}
        <div className="header-top">
          <div className="container">
            <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
              {/* Left Side: Contact / Hours */}
              <div className="col-auto d-none d-lg-block">
                <div className="header-links">
                  <ul>
                    <li>
                      <i className="fas fa-envelope" />
                      <Link to="mailto:taller@lealchapaypintura.com">
                        taller@lealchapaypintura.com
                      </Link>
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt" />
                      <Link to="https://www.google.com/maps/place//data=!4m2!3m1!1s0xd126d27da03445b:0x4605fa9dd282f634?sa=X&amp;ved=1t:8290&amp;ictx=111">
                        <span>C. Congreso, 57 | Pol. P.I.S.A</span>
                      </Link>
                    </li>
                    <li>
                      <i className="fas fa-clock" />
                      {loading && <span>Horario: cargando...</span>}
                      {!loading && error && <span>Horario: no disponible</span>}
                      {!loading && !error && (statusMessage || summary) && (
                        <span style={{ color: isOpen ? '#28a745' : '#dc3545' }}>
                          {statusMessage || summary}
                        </span>
                      )}
                    </li>
                  </ul>
                </div>
              </div>

              {/* Right Side: Social Icons */}
              <div className="col-auto">
                <div className="header-links ps-0">
                  <ul>
                    <li>
                      <div className="social-links">
                        <Link to="https://www.facebook.com/people/Leal-chapa-y-pintura/100063494171024/">
                          <i className="fab fa-facebook-f" />
                        </Link>
                        <Link to="https://www.instagram.com/lealchapaypintura">
                          <i className="fab fa-instagram" />
                        </Link>
                        <Link to="https://wa.me/+34698925394">
                          <i className="fab fa-whatsapp" />
                        </Link>
                        <Link to="https://www.linkedin.com/company/leal-chapa-y-pintura">
                          <i className="fab fa-linkedin" />
                        </Link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sticky Wrapper */}
        <div className={`sticky-wrapper ${scroll ? "sticky" : ""}`}>
          {/* Main Menu Area */}
          <div className="menu-area">
            {/* Logo (Left) */}
            <div className="header-navbar-logo">
              <Link to="/">
                <img src="/assets/img/logo.svg" alt="LealChapayPintura.com" />
              </Link>
            </div>

            <div className="container">
              <div className="row align-items-center justify-content-lg-start justify-content-between">
                {/* Mobile Logo (Hidden on xl) */}
                <div className="col-auto d-xl-none d-block">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assets/img/logo.svg" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>

                {/* Desktop Menu */}
                <div className="col-auto">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <ul>
                      <li>
                        <NavLink
                          to="/nosotros"
                          className={(navData) => (navData.isActive ? "active" : "")}
                        >
                          Conócenos
                        </NavLink>
                      </li>
                      <li className="menu-item-has-children">
                        <Link to="/chapa-y-pintura">Chapa y Pintura</Link>
                        <ul className="sub-menu">
                          {CHAPA_SERVICES_DATA.map((service) => (
                            <li key={service.slug}>
                              <NavLink
                                to={`/chapa-y-pintura/${service.slug}`}
                                className={(navData) => (navData.isActive ? "active" : "")}
                              >
                                {service.title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                      <li className="menu-item-has-children">
                        <Link to="/mecanica">Mecánica</Link>
                        <ul className="sub-menu">
                          {MECANICA_SERVICES_DATA.map((service) => (
                            <li key={service.slug}>
                              <NavLink
                                to={`/mecanica/${service.slug}`}
                                className={(navData) => (navData.isActive ? "active" : "")}
                              >
                                {service.title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                      <li className="menu-item-has-children">
                        <Link to="/mantenimiento">Mantenimiento</Link>
                        <ul className="sub-menu">
                          {MANTENIMIENTO_SERVICES_DATA.map((service) => (
                            <li key={service.slug}>
                              <NavLink
                                to={`/mantenimiento/${service.slug}`}
                                className={(navData) => (navData.isActive ? "active" : "")}
                              >
                                {service.title}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </li>
                      <li>
                        <NavLink
                          to="/alquiler"
                          className={(navData) => (navData.isActive ? "active" : "")}
                        >
                          Alquiler de Vehículos
                        </NavLink>
                      </li>
                    </ul>
                  </nav>

                  {/* Mobile Menu Button */}
                  <div className="navbar-right d-inline-flex d-lg-none">
                    <button
                      type="button"
                      className="menu-toggle icon-btn"
                      onClick={mobileMenu}
                    >
                      <i className="fas fa-bars" />
                    </button>
                  </div>
                </div>

                {/* WhatsApp Contact (Right on Desktop) */}
                <div className="col-auto ms-auto d-xl-block d-none">
                  <div className="navbar-right-desc">
                    <img src="/assets/img/icon/about_icon2-4.svg" alt="LealChapayPintura.com" />
                    <div className="navbar-right-desc-details">
                      <h6 className="title">¿A que estas esperando?</h6>
                      <a className="link" href={CONTACT.whatsapp.link} onClick={trackWhatsAppContact} target="_blank" rel="noopener noreferrer">
                        Contáctanos por WhatsApp
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="logo-bg" />
          </div>
        </div>

        {/* Mobile Menu Wrapper */}
        <div className={`mobile-menu-wrapper ${active ? "body-visible" : ""}`}>
          <div className="mobile-menu-area">
            {/* Mobile Logo & Close Button */}
            <div className="mobile-logo">
              <Link to="/">
                <img src="/assets/img/logo-black.svg" alt="LealChapayPintura" />
              </Link>
              <button className="menu-toggle" onClick={mobileMenu}>
                <i className="fa fa-times" />
              </button>
            </div>

            {/* Mobile Navigation */}
            <div className="mobile-menu">
              <ul id="offcanvas-navigation">
                <li>
                  <NavLink
                    to="/nosotros"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Conócenos
                  </NavLink>
                </li>
                <li className="menu-item-has-children">
                  <Link to="/chapa-y-pintura">Chapa y Pintura</Link>
                  <ul className="sub-menu">
                    {CHAPA_SERVICES_DATA.map((service) => (
                      <li key={service.slug}>
                        <NavLink
                          to={`/chapa-y-pintura/${service.slug}`}
                          className={(navData) => (navData.isActive ? "active" : "")}
                        >
                          {service.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="menu-item-has-children">
                  <Link to="/mecanica">Mecánica</Link>
                  <ul className="sub-menu">
                    {MECANICA_SERVICES_DATA.map((service) => (
                      <li key={service.slug}>
                        <NavLink
                          to={`/mecanica/${service.slug}`}
                          className={(navData) => (navData.isActive ? "active" : "")}
                        >
                          {service.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="menu-item-has-children">
                  <Link to="/mantenimiento">Mantenimiento</Link>
                  <ul className="sub-menu">
                    {MANTENIMIENTO_SERVICES_DATA.map((service) => (
                      <li key={service.slug}>
                        <NavLink
                          to={`/mantenimiento/${service.slug}`}
                          className={(navData) => (navData.isActive ? "active" : "")}
                        >
                          {service.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <NavLink
                    to="/alquiler"
                    className={(navData) => (navData.isActive ? "active" : "")}
                  >
                    Alquiler de Vehículos
                  </NavLink>
                </li>
              </ul>

              {/* Extra Mobile Links (Phone & Social) */}
              <ul className="offcanvas-extra-links">
                <li>
                  <NavLink to="tel:+34698925394">
                    <strong>Llámanos (+34) 698 92 53 94</strong>
                  </NavLink>
                </li>
                <li>
                  <a className="link" href={CONTACT.whatsapp.link} onClick={trackWhatsAppContact} target="_blank" rel="noopener noreferrer">
                    <h6 className="title">Contáctanos por WhatsApp</h6>
                  </a>
                </li>
                <li>
                  <div className="header-links ps-0">
                    <ul>
                      <li>
                        <div className="social-links">
                          <Link to="https://www.facebook.com/people/Leal-chapa-y-pintura/100063494171024/">
                            <i className="fab fa-facebook-f" />
                          </Link>
                          <Link to="https://www.instagram.com/lealchapaypintura">
                            <i className="fab fa-instagram" />
                          </Link>
                          <Link to="https://wa.me/+34698925394">
                            <i className="fab fa-whatsapp" />
                          </Link>
                          <Link to="https://www.linkedin.com/company/leal-chapa-y-pintura">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderOne;
